module.exports = __webpack_public_path__ + "static/img/img_light_1.af24138.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lottery/img_light_1.png
// module id = kEmH
// module chunks = 1